import { UserRole } from '../user-role';

import { UserBaseFormControls } from './user-base.form';
import { UserAccountManagerForm } from './user-account-manager.form';

export class UserAccountManagerTrustedForm extends UserAccountManagerForm {
    constructor() {
        super();
    }

    override initForm(): void {
        super.initForm();
        this.form.get(UserBaseFormControls.Role)?.setValue(UserRole.AccountManagerTrusted);
    }
}
